import cn from "classnames";
import FileBody from "components/shared/fileBody";
import Popover from "components/shared/popover";
import WithMentions from "components/shared/withMentions";
import { dateToView } from "helpers/date";
import { userMessageFlagsEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";

const Message = (props) => {
    const { createdBy, text, userId, createdById, index, userMessagesInfo, driver, bidId } = props;

    const [actionsOpened, setActionsOpened] = useState(false);
    const [showInfo, setShowInfo] = useState(false);

    const mentioned = useMemo(() => {
        const myMessageInfo = userMessagesInfo?.find((item) => item.recipient.id === userId);
        if (!myMessageInfo) {
            return false;
        }
        return myMessageInfo.flags.includes(userMessageFlagsEnum.Mentioned);
    }, [userMessagesInfo, userId]);

    const cname = cn({
        "chat__body-item chat-msg": true,
        "chat-msg--my": createdById === userId,
        "chat-msg--other": createdById !== userId,
        "chat-msg--mentioned": mentioned,
    });

    const renderActions = () => {
        const items = [
            {
                text: "Информация о сообщении",
                action: (e) => {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    setShowInfo(true);
                },
                available: true,
            },
            { text: "Копировать", action: () => navigator.clipboard.writeText(text), available: !!text },
        ].filter((item) => item.available);
        return (
            <div className={cn("chat-msg__actions-wrap", { "chat-msg__actions-wrap--opened": actionsOpened })}>
                <Popover
                    withoutChevron
                    onOpen={() => setActionsOpened(true)}
                    onClose={() => {
                        setShowInfo(false);
                        setActionsOpened(false);
                    }}
                    cname="chat-msg__actions"
                    text={<i className="icon-uEA0D-menu" />}
                    positions={index > 2 ? ["top"] : ["bottom"]}
                    align={createdById === userId ? "end" : "start"}
                >
                    {showInfo ? (
                        <div className="chat-msg__info pb-2">
                            Отправлено водителю: {driver}
                            <br />В заявке:&nbsp;
                            <Link to={paths.bidShow("bid", bidId)} target="_blank">
                                {bidId}
                            </Link>
                        </div>
                    ) : (
                        items.map((item, i) => (
                            <div key={i} className="dropdown__item" onClick={item.action}>
                                {item.text}
                            </div>
                        ))
                    )}
                </Popover>
            </div>
        );
    };

    const renderBody = () => {
        return !text && props.file ? (
            <FileBody {...props} />
        ) : (
            <div className="chat-msg__body chat-msg__body--text">
                <WithMentions text={text} />
            </div>
        );
    };

    const { readByAllUsers, readByOneUser } = useMemo(
        () =>
            userMessagesInfo?.reduce(
                (acc, item) =>
                    item.isIntegrationAccount
                        ? acc
                        : {
                              readByAllUsers: acc.readByAllUsers && item.isRead,
                              readByOneUser: acc.readByOneUser || item.isRead,
                          },
                { readByAllUsers: true, readByOneUser: false },
            ) ?? {},
        [userMessagesInfo],
    );

    return (
        <div key={props.id} className={cname}>
            {createdBy && createdById !== userId && (
                <div className="chat-msg__head">
                    <div className="d-flex justify-content-between">
                        <span className="pr-1 ellipsis">{createdBy.fullName}</span>
                    </div>
                </div>
            )}
            {renderActions()}
            {renderBody()}
            <span className="chat-msg__date">
                <span
                    className={cn({
                        "chat-msg__checkmark": !readByOneUser,
                        "chat-msg__double-checkmark": readByOneUser,
                        "chat-msg__double-checkmark--readed": readByAllUsers && readByOneUser,
                    })}
                />
                {dateToView(props.createdAt, "HH:mm")}
            </span>
        </div>
    );
};

export default Message;
